'use client';

import { useEffect, useState, useRef } from 'react';

export function useScrollDirection() {
	const [isScrolled, setIsScrolled] = useState(false);
	const prevScroll = useRef(0);

	useEffect(() => {
		const handleScroll = () => {
			const currentScroll = window.scrollY;
			const scrollingDown = currentScroll > prevScroll.current && currentScroll > 0;

			setIsScrolled(scrollingDown);

			prevScroll.current = currentScroll;
		};

		window.addEventListener('scroll', handleScroll, { passive: true });
		handleScroll(); // Run once on mount

		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	return isScrolled;
}
